/**
 * Analytics/tracking stub — Google Tag Manager, Google Ads gtag and Meta
 * Pixel were intentionally removed at the owner's request.
 *
 * This file keeps the same export surface so every existing caller
 * continues to compile, but every function is now a no-op. Do NOT
 * re-introduce third-party tracking here without an explicit ask.
 */

const _NOOP = () => {};

export function installGoogleAdsTag() { _NOOP(); }
export function fireConversion() { _NOOP(); }
export function fireActivation() { _NOOP(); }
export const googleAdsConfigured = false;
export function firePageView() { _NOOP(); }
export function fireGetStarted() { _NOOP(); }
export function fireLeadFormSubmit() { _NOOP(); }
